<template>
  <div>

    <form @submit.prevent="onSubmit" v-if="user">

      <div class="mt-6">
        <label class="font-bold" for="name">Apotekets kontaktperson:</label>
        <div class="mt-1">
          <input class="w-full" :class="{'invalid': errors.Name }" type="text" id="name" v-model="user.name" ref="name">
        </div>
      </div>

      <div class="mt-6 hidden">
        <label class="font-bold" for="email">Kontaktpersonens e-post:</label>
        <div class="mt-1">
          <input class="w-full text-gray-500" :class="{'invalid': errors.Email }" type="email" id="email" v-model="user.email" readonly>
        </div>
      </div>

      <div class="mt-6">
        <label class="font-bold" for="phone">Kontaktpersonens telefon:</label>
        <div class="mt-1">
          <input class="w-full" :class="{'invalid': errors.Phone }" type="text" id="phone" v-model="user.phone">
        </div>
      </div>

      <div class="flex justify-between mt-16">
        <button class="btn" @click.prevent="onPrevClick">
          <font-awesome-icon :icon="['far', 'chevron-left']" />
          <span class="inline-block ml-4">Forrige</span>
        </button>
        <button class="btn btn-primary" type="submit">
          <span class="inline-block mr-4">Neste</span> <font-awesome-icon :icon="['far', 'chevron-right']" />
        </button>
      </div>

    </form>
  </div>

</template>

<script>
import api from '@/api'
export default {
  name: 'ap-register-contact',
  data () {
    return {
      user: null,
      errors: {}
    }
  },
  methods: {
    onPrevClick () {
      this.$emit('prev')
    },
    async onSubmit () {
      const response = await api.ap.updateUser(this.user)
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$emit('submit')
      }
    }
  },
  async mounted () {
    this.user = await api.ap.getUser()
  }
}
</script>
